export default __webpack_public_path__ + "static/media/overcast_podcast.5eb9cab3.svg";